<template>
  <div class="simulator-app form-style">
    <div class="title">
      Simulateur Express
    </div>
    <div class="simulateur-express-form">
      <div class="form-group">
        <label>Montant *</label>

        <vue-autonumeric
          @input="calculMensualite(montantFlag)"
          v-model="montant"
          :options="options"
        ></vue-autonumeric>
      </div>

      <div class="form-group">
        <label>Durée et taux *</label>

        <select
          @change="
            calculMensualite();
            calculMontant();
          "
          v-model="duree"
        >
          <option
            :key="taux.duree"
            :value="taux.duree"
            v-for="taux in tauxSimulateurs"
            >Sur {{ taux.duree }} ans ({{ taux.taux }}%)</option
          >
        </select>
      </div>
      <div class="form-group">
        <label>Mensualités *</label>
        <vue-autonumeric
          v-on:input="calculMontant(mensualiteFlag)"
          v-model="mensualite"
          :options="options"
        ></vue-autonumeric>
      </div>
    </div>
  </div>
</template>

<script>
import common from './common.js';
import Vue from 'vue';
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';

import Cleave from 'vue-cleave-component';
Vue.use(Cleave);
Vue.filter('formatNumber', function(number) {
  if (number) {
    return number.toFixed(2);
  }
});

export default {
  components: {
    VueAutonumeric,
  },
  mounted() {
    this.taux = window.taux;
    this.tauxSimulateurs = window.tauxSimulateurs;
    let tmpDuree = this.tauxSimulateurs[0];
    if (tmpDuree) {
      this.duree = tmpDuree.duree;
    }
  },

  computed: {
    tauxAnnuel() {
      let item = this.tauxSimulateurs.find(item => {
        if (item.duree === this.duree) {
          return item;
        }
      });
      if (item) {
        return item.taux;
      }
    },
    tauxAnnuelSousUn() {
      return this.tauxAnnuel / 100;
    },
    tauxMensuelSousUn() {
      return this.tauxAnnuelSousUn / 12;
    },
    dureeCreditEnMois() {
      return this.duree * 12;
    },
    mensualiteBrute() {
      return this.montant / (this.duree * 12);
    },
    coutEmprunt() {
      return this.mensualite * this.dureeCreditEnMois;
    },
  },
  data() {
    return {
      montantFlag: false,
      mensualiteFlag: false,
      tauxSimulateurs: [],
      taux: {},
      duree: null,
      montant: 0,
      mensualite: 0,
      mensualiteFocused: false,
      montantFocused: false,
      dureeFocused: false,
      options: {
        digitGroupSeparator: ' ',
        decimalCharacter: '.',
        decimalCharacterAlternative: '.',
        currencySymbol: '\u00a0€',
        currencySymbolPlacement: 's',
        roundingMethod: 'U',
        minimumValue: '0',
        decimalPlaces: 0,
        decimalPlacesRawValue: 0,
      },
    };
  },
  methods: {
    calculate() {},
    calculMontant(mensualiteFlag) {
      if (mensualiteFlag) return;

      this.montantFlag = true;

      this.montant =
        ((1 - Math.pow(1 + this.tauxMensuelSousUn, -this.dureeCreditEnMois)) *
          this.mensualite) /
        this.tauxMensuelSousUn;

      this.$nextTick(() => {
        this.montantFlag = false;
      });
    },
    calculMensualite(montantFlag) {
      if (montantFlag) return;
      this.mensualiteFlag = true;

      this.mensualite =
        (this.montant * this.tauxMensuelSousUn) /
        (1 - Math.pow(1 + this.tauxMensuelSousUn, -this.dureeCreditEnMois));

      this.$nextTick(() => {
        this.mensualiteFlag = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
